(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"));
	else if(typeof define === 'function' && define.amd)
		define("CashierPaymentsWrapper", ["React"], factory);
	else if(typeof exports === 'object')
		exports["CashierPaymentsWrapper"] = factory(require("React"));
	else
		root["CashierPaymentsWrapper"] = factory(root["React"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_17__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition